export async function getData(_, requestOptions, optionsString) {
  const PUBLIC_KEY = "AIzaSyBy8p6YmU2Pfs_d3smaLydp73AOCpjijp8";
  const CALENDAR_ID = "ks3gbmei6igc9nuad91fl21ru8@group.calendar.google.com";

  const dataUrl = [
    "https://www.googleapis.com/calendar/v3/calendars/",
    CALENDAR_ID,
    "/events?key=",
    PUBLIC_KEY,
    "&singleEvents=true&orderBy=startTime&maxResults=2500&",
    Object.keys(optionsString)
      .map((key) => `${key}=${optionsString[key]}`)
      .join("&"),
  ].join("");

  try {
    const result = await fetch(dataUrl, requestOptions);
    const response = await result.json();
    return { data: response.items, error: null };
  } catch (e) {
    console.error(e);
    return { data: {}, error: e };
  }
}

export const getDateString = (date, isStart = true, isToday = false) => {
  // const newDateString = `${date.getFullYear()}-${(date.getMonth() + 1)

  // const newDateString = `${date.getFullYear()}-${isStart ? "01" : "12"}-${date
  //   .getDate()
  //   .toString()
  //   .padStart(2, "0")}`;

  const newDateString = `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

  return `${newDateString}T${
    isStart ? "00:00:00" : isToday ? "22:00:00" : "23:59:00"
  }.000Z`;
};
